<template>
  <div class="d-flex justify-content-end mt-2">
    <div>
      <div class="d-flex justify-content-end small">
        Motion Version {{ version }} ©2022
        <a
          href="https://l2x.tech"
          class="text-decoration-none ml-1"
        >L2X</a>. All rights reserved.
      </div>
      <div class="d-flex justify-content-end small">
        For support please contact
        <a
          href="mailto:motion.support@l2x.tech"
          class="text-decoration-none ml-1"
        >motion.support@l2x.tech</a>.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    version () {
      // remove 'v' prefix
      let ver = process.env.VUE_APP_VERSION
      if (ver.startsWith('v')) {
        ver = ver.substring(1)
      } else if (ver.startsWith(process.env.VUE_APP_BRAND + '-v')) {
        ver = ver.substring(process.env.VUE_APP_BRAND.length + 2)
      } else if (ver.length > 8 && this.isHex(ver)) {
        return ver.substring(0, 8)
      }
      return ver
    },
  },
  methods: {
    isHex (s) {
      return /^[0-9A-Fa-f]+$/.test(s)
    },
  },
}
</script>
